import { render, staticRenderFns } from "./ChainSettingsCard.vue?vue&type=template&id=a213d61c"
import script from "./ChainSettingsCard.vue?vue&type=script&lang=ts"
export * from "./ChainSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports